<template>
  <div class="footer-box">
    <div class="footer-cont">
      <div class="footer-left">
        <div class="footer-info-left">
          <p>版权所有：鄂尔多斯市融资担保有限公司</p>
          <p>指导单位：鄂尔多斯市人民政府金融工作办公室</p>
          <p>技术支持：内蒙古中诚信信用管理有限公司</p>
          <p>
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >蒙ICP备19004877号&nbsp;&nbsp;&nbsp;&nbsp;蒙ICP备19004877号-2</a
            >
          </p>
        </div>
        <div class="footer-info-right">
          <div class="line"></div>
          <div class="right-cont">
            <div class="info-right-item">
              <img src="../assets/images/icon/icon-phone.png" />
              <span>联系方式</span>
              <p>0477-8382002</p>
            </div>
            <div class="info-right-item">
              <img src="../assets/images/icon/icon-eye.png" />
              <span>访问总量</span>
              <p>{{ totalView }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <img src="../assets/images/index/ercode.png" width="132px" />
      </div>
    </div>
  </div>
</template>

<script>
import { dataSource } from "@/api/api.js";
export default {
  props: {},
  name: "footerBox",
  components: {},
  data() {
    return {
      todayView: 0,
      totalView: 0,
    };
  },
  created() {
    this.postRecordViewsFn();
    this.getViewsFn();
  },
  computed: {},
  methods: {
    postRecordViewsFn() {
      //浏览记录自增
      dataSource
        .postRecordViews()
        .then((res) => {})
        .catch((err) => {});
    },
    getViewsFn() {
      //获取浏览次数
      dataSource
        .getViews()
        .then((res) => {
          if (res.data.code === 1) {
            this.todayView = res.data.data.dayViews;
            this.totalView = res.data.data.totalViews;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="less">
.footer-box {
  background-color: #0f43a2;
  height: 180px;
  color: #5e98e9;
  .footer-cont {
    display: flex;
    width: 1200px;
    height: 180px;
    margin: 0 auto;
    .footer-left {
      display: flex;
      width: 1000px;
      color: #5e98e9;
      margin-top: 32px;
      .footer-info-left {
        width: 500px;
        p {
          font-size: 12px;
          color: #ccc;
          font-weight: 400;
          line-height: 22px;
          margin-bottom: 12px;
          a {
            color: #ccc;
          }
        }
      }
      .footer-info-right {
        width: 500px;
        padding-left: 40px;
        display: flex;
        .line {
          width: 1px;
          height: 74px;
          background: #5e98e9;
          position: relative;
          top: 24px;
          right: 40px;
        }
        .right-cont {
          .info-right-item {
            margin-bottom: 18px;
            img {
              width: 21px;
              height: 21px;
            }
            p {
              font-size: 12px;
              color: #ccc;
              font-weight: 400;
              line-height: 22px;
              margin-left: 28px;
            }
            span {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 400;
              color: #ccc;
              line-height: 22px;
              position: relative;
              top: -6px;
              left: 6px;
            }
          }
        }
      }
    }
    .footer-right {
      width: 200px;
      text-align: right;
      vertical-align: middle;
      align-items: center;
      justify-content: center;
      img {
        margin-top: 23px;
      }
    }
  }
}
</style>
